export default "/_next/static/images/img2-0f1744a462ace7d9fc50bff9cf829d08.png";